import React from 'react';
import PropTypes from 'prop-types';
import paths from './paths';
import getUniqueId from '../../utils/getUniqueId';
import Face from '../common/face/Face';
import Wrapper from '../common/wrapper/Wrapper';

var Ghost = function Ghost(_ref) {
  var size = _ref.size,
      color = _ref.color,
      mood = _ref.mood,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement("svg", {
    width: size * 0.77,
    height: size,
    viewBox: "0 0 130 168",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kawaii-ghost"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kawaii-ghost__body"
  }, /*#__PURE__*/React.createElement("path", {
    d: paths.shape,
    id: "kawaii-ghost__shape",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.shadow,
    id: "kawaii-ghost__shadow",
    fillOpacity: ".1",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement(Face, {
    mood: mood,
    transform: "translate(34 57)",
    uniqueId: getUniqueId()
  }))));
};

Ghost.propTypes = {
  /**
   * Size of the width
   * */
  size: PropTypes.number,
  mood: PropTypes.oneOf(['sad', 'shocked', 'happy', 'blissful', 'lovestruck', 'excited', 'ko']),

  /**
   * Hex color
   */
  color: PropTypes.string
};
Ghost.defaultProps = {
  size: 240,
  mood: 'blissful',
  color: '#E0E4E8'
};
export default Ghost;